<template lang="pug">
div
  table.tech-map-tab-table.issues-table
    thead
      tr
        th(v-for="column in tab_data.columns", :key="column.name")
          span.column-header-title {{ column.label }}
    tbody
      tr(v-for="issue_data in data", @click="openShow({ id: issue_data.id, type: issue_data.type })")
        td(v-for="td in issue_data.rows", :key="getTdKey(issue_data, td)", :class="td.key", :style="td.style")
          span {{ tryFormatToDate(td.value) }}

  grid-modals(
    ref="issueModal",
    :parentData="{ grid: 'issues', grid_key: 'data', path: '/api/v3/dynamic/issues', facility_id: parentData?.row?.facility_id, transition_key: 'issue', row: {} }"
  )
  grid-modals(
    ref="pprIssueModal",
    :parentData="{ grid: 'ppr_issues', grid_key: 'data', path: '/api/v3/ppr/issues', facility_id: parentData?.row?.facility_id, row: {} }"
  )
</template>

<script>
import { format } from "date-fns";
import { handleError } from "@/services/handleErrors";
import GridModals from "@/components/shared/grid/gridModals";

export default {
  components: {
    GridModals,
  },

  props: {
    parentData: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      path: this.parentData.path,
      grid: this.parentData.grid,
      tab_data: this.parentData.tab_data,
      row_id: this.parentData.row_id,
    };
  },

  computed: {
    data() {
      return this.parentData.data;
    },
  },

  created() {
    this.initializeGrids();
  },

  methods: {
    async initializeGrids() {
      try {
        this.$store.commit("initialGridsState", { grid: "issues" });
        this.$store.commit("initialGridsState", { grid: "ppr_issues" });
        this.$store.commit("initialGrid", { grid_name: "issues", grid_key: "data" });
        this.$store.commit("initialGrid", { grid_name: "ppr_issues", grid_key: "data" });

        const { data } = await this.$backend.index("api/v3/expenses_dashboard/issues_actions", {});

        const crud = data.crud.issues;
        const pprCrud = data.crud.ppr_issues;

        delete data.crud;

        const actions = { ...data };
        const pprActions = { ...data };

        actions["crud"] = crud;
        pprActions["crud"] = pprCrud;

        this.$store.commit("updateActions", { grid_name: "issues", grid_key: "data", actions: actions });
        this.$store.commit("updateActions", { grid_name: "ppr_issues", grid_key: "data", actions: pprActions });
      } catch (e) {
        await handleError(e);
      }
    },
    openShow(issue) {
      if (issue.type === "MaintenanceIssue") {
        this.$refs.issueModal.openShow({ id: issue.id });
      } else {
        this.$refs.pprIssueModal.openShow({ id: issue.id });
      }
    },
    tryFormatToDate(str) {
      if (typeof str === "string") {
        const dateArr = str.split("T");

        if (dateArr.length > 1) {
          const date = new Date(str);
          if (date != "Invalid Date") {
            return format(date, "dd.MM.yyyy, HH:mm");
          }
          return str;
        }
      }

      return str;
    },
    getTdKey(data, td) {
      return `${data.id}_${td.key}`;
    },
  },
};
</script>

<style lang="scss"></style>
